import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logoFallback from '../../../assets/images/lightlogo.png';
import icon from '../../../assets/images/icon.png';
import { getSettings } from '../../../services/settingsService';
import ImageShow from "../../../Uitiles/ImageShow";

const Footer = () => {

    const [settings, setSettings] = useState({});

    useEffect(() => {
        getSettings().then(settings => {
            setSettings(settings);
        });
    }, []);

    return (
        <footer id="dc-footer" className="dc-footer dc-haslayout">
            <div className="dc-footertopbar">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="dc-fcall-email-wrap">
                                <div className="dc-footer-call-email">
                                    <div className="dc-callinfoholder">
                                        <figure className="dc-callinfoimg">
                                            <img width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/08/img-01.png" alt="MeddyList" />
                                        </figure>
                                        <div className="dc-callinfocontent">
                                            <h3><span>Emergency Cal</span> <a href={`tel:${settings.emergency_help_number}`}>{settings.emergency_help_number}</a></h3>
                                        </div>
                                    </div>
                                    <div className="dc-callinfoholder dc-mailinfoholder">
                                        <figure className="dc-callinfoimg">
                                            <img width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/08/img-02-1.png" alt="MeddyList" />
                                        </figure>
                                        <div className="dc-callinfocontent">
                                            <h3><span>24/7 Email Support</span> <a href={`mailto:${settings.emergency_help_email}`}>{settings.emergency_help_email}</a></h3>
                                        </div>
                                    </div>
                                    <span className="dc-or-text">- OR -</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dc-fthreecolumns">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 float-left">
                            <div id="doctreat_contactinfo-2" className="dc-widget dc-widgetarticlesholder dc-copntactinfowidtget dc-fcol dc-widgetcontactus dc-widget">
                                <strong className="dc-logofooter">
                                    <Link to="/">
                                        {settings.site_footer_logo_url ? (
                                            <ImageShow url={settings.site_footer_logo_url} alt="MeddyList" />
                                        ) : (
                                            <img src={logoFallback} alt="MeddyList" />
                                        )}
                                    </Link>
                                </strong>
                                <div className="dc-footercontent">
                                    <div className="dc-description">
                                        <p>{settings.site_description}</p>
                                    </div>
                                    <ul className="dc-footercontactus">
                                        <li><address><i className="lnr lnr-location"></i> {settings.emergency_help_address}</address></li>
                                        <li><a href="#"><i className="lnr lnr-envelope"></i> {settings.emergency_help_email}</a></li>
                                        <li><span><i className="lnr lnr-phone-handset"></i> {settings.emergency_help_number}</span></li>
                                    </ul>
                                    <div className="dc-fsocialicon">
                                        {/* <ul className="dc-simplesocialicons">
                                            <li className="dc-facebook"><a target="_blank" href={settings.facebook_url}><i className="fab fa-facebook-f"></i></a></li>
                                            <li className="dc-twitter"><a target="_blank" href={settings.twitter_url}><i className="fab fa-twitter"></i></a></li>
                                            <li className="dc-linkedin"><a target="_blank" href={settings.linkedin_url}><i className="fab fa-linkedin-in"></i></a></li>
                                            <li className="dc-googleplus"><a target="_blank" href={settings.google_plus_url}><i className="fab fa-google-plus-g"></i></a></li>
                                            <li className="dc-rss"><a target="_blank" href="#"><i className="fa fa-rss"></i></a></li>
                                            <li className="dc-youtube"><a target="_blank" href={settings.youtube_url}><i className="fab fa-youtube"></i></a></li>
                                        </ul> */}
                                    </div>
                                </div>
                            </div>									</div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 float-left">
                            <div id="doctreat_tweets-2" className="dc-widgettwitter dc-fcol dc-flatestad dc-twitter-live-wgdets dc-widgetcontactus dc-widget"><div className="dc-ftitle"><h3>Twitter Live Feed</h3></div>					<div className="txt-box">
                                <p>{settings.twitter_live_feed}</p>
                            </div>
                            </div>									</div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 float-left">
                            <div id="doctreat_newsletters-2" className=" dc-fcol dc-newsletterholder dc-widgetcontactus dc-widget">
                                <div className="dc-ftitle"><h3>Subscribe to our newsletter</h3></div>
                                <div className="dc-footercontent dc-newsletterholder">
                                    <div className="dc-description"><p>Subscribe to our newsletter to get the latest news and updates.</p></div>
                                </div>
                                <form className="dc-formtheme dc-formnewsletter comingsoon-newsletter" id="mailchimpwidget_1">
                                    <fieldset>
                                        <div className="form-group">
                                            <input type="email" name="email" value="" className="form-control" placeholder="Enter your email" required="" />
                                            <button type="submit" className="subscribe_me" data-counter="1"><i className="lnr lnr-arrow-right"></i></button>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                            <div id="doctreat_apps_downloads-2" className="dc-footerapps dc-fcol dc-newsletterholder dc-widgetcontactus dc-widget">
                                <ul className="dc-btnapps">
                                    <li>
                                        <a href="#">
                                            <img width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/09/img-06-1.png" alt="Android app" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <img width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/09/img-05-1.png" alt="Android app" />
                                        </a>
                                    </li>
                                </ul>
                                <div class="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '100%' }}>
                                    <div class="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex" style={{ gap: '30px' }}>
                                        <div class="wp-block-button is-style-outline is-style-outline--1">
                                            <Link class="wp-block-button__link wp-element-button" to="/terms-and-conditions">
                                                <mark style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }} class="has-inline-color has-very-light-gray-color">Terms and Conditions</mark>
                                            </Link>
                                        </div>
                                        <div class="wp-block-button is-style-outline is-style-outline--2">
                                            <Link class="wp-block-button__link wp-element-button" to="/privacy-policy">
                                                <mark style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }} class="has-inline-color has-very-light-gray-color">Privacy Policy</mark>
                                            </Link>
                                        </div>
                                        <div class="wp-block-button is-style-outline is-style-outline--3">
                                            <Link class="wp-block-button__link wp-element-button" to="/refund_returns">
                                                <mark style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }} class="has-inline-color has-very-light-gray-color">Refund policy</mark>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="dc-footerbottom dc-widget-enabled">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-12">
                            <p className="dc-copyright">Copyrights © 2019 by <span>MeddyList Digital Private Limited</span>. All Rights Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
